import { isRef } from "vue";

export const unwrapRef = (value: any) => {
    return isRef(value) ? value.value : value;
};
